import { TRoleName } from '../model/IRole'

// --
// -- Pages
// --
export type TPageUrl =
  | '/oauth/signIn'
  | '/oauth/signUp'
  | '/oauth/remind'
  | '/oauth/activate'
  | '/dashboard'
  | '/new-import'
  | '/imports'
  | '/tracking'
  | '/settings'
  | '/dev'

export type TRoleNameWithUnion = TRoleName | '*'

type IAccess<T extends string | number | symbol> = {
  [key in T]: Partial<TRoleNameWithUnion>[]
}

// --
// -- Access map
// --
export const pagesAccess: IAccess<TPageUrl> = {
  '/oauth/signIn': ['*'],
  '/oauth/signUp': ['*'],
  '/oauth/remind': ['*'],
  '/oauth/activate': ['*'],

  '/dashboard': ['admin', 'user', 'superadmin'],
  '/new-import': ['admin', 'user', 'superadmin'],
  '/imports': ['admin', 'user', 'superadmin'],
  '/tracking': ['admin', 'user', 'superadmin'],
  '/settings': ['admin', 'user', 'superadmin'],

  '/dev': ['superadmin'],
}

// -- Setting access
// export type TSettingNames =
// | 'account'
// | 'goals'
// ;

export const settingAccess = {
  // 'account': ['ROLE_ADMIN', 'ROLE_USER'],
  // 'goals': ['ROLE_ADMIN'],
  // 'otherUserStatistic': ['ROLE_ADMIN']
}

export type TSettingNames = keyof typeof settingAccess
